// Global Event Bus

import Vue from "vue";
export default new Vue();
